export const environment = {
   apiBaseUrl: '',
   appClientId: '8',
   appClientSecret: 'U5oCcoCa9isMyUAt2zrcIEbizcNb4WxDY20FxGyO',
   nodeEnv: 'development',
   production: false
};
